import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppLockProvider } from '@/components/AppLock';
import { AlertProvider } from '@ascend/alert';
import { AppGate } from '@/AppGate';
import 'calc-controls/styles.css';
import 'calc-nav/styles.css';
import '@/styles/tokens.css';
import '@/styles/global.css';
import '@/styles/print.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AppLockProvider>
      <AlertProvider>
        <AppGate />
      </AlertProvider>
    </AppLockProvider>
  </React.StrictMode>
);
